import React, { useEffect, useState } from "react";

import $ from "jquery";
import { ToastContainer } from 'react-toastify';

import bg_01 from "../images/bg/bg-02.jpg";

import { loadBackgroundImages, imagesJSON } from "../components/background/Background";
import { defaultSettings, getComponentValue, getConfigComponent } from "../components/tab_options/settings/Config";

import FavoritesApps from "../components/favorites_apps/FavoritesApps";
import Apps from "../components/apps/Apps";
import Options from "../components/options/Options";
import Footer from "../components/footer/Footer";

import blindFilter from "../images/filters.svg";

import "./_home.scss";
import "./_dark.scss";

function Home() {
	let countdown = 5;
	const [autoHideInterval, setAutoHideInterval] = useState(null);
	const [selectedImage, setSelectedImage] = useState(null);
	const [animation, setAnimation] = useState(getComponentValue("animation"));
	const [showApps, setShowApps] = useState(getComponentValue("showApps"));
	const [configApps, setConfigApps] = useState(getConfigComponent("configApps"));
	const [showFavorites, setShowFavorites] = useState(getComponentValue("showFavorites"));
	const [configFavorites, setConfigFavorites] = useState(getConfigComponent("configFavorites"));
	const [configFooter, setConfigFooter] = useState(getConfigComponent("configFooter"));
	const [showFooter, setShowFooter] = useState(getComponentValue("showFooter"));
	const [lang, setLang] = useState(getComponentValue("language"));
	const [settings, setSettings] = useState((localStorage.getItem('settings')) ? JSON.parse(localStorage.getItem("settings")) : defaultSettings);
	const [favorites, setFavorites] = useState((localStorage.getItem('dataFavorite')) ? JSON.parse(localStorage.getItem("dataFavorite")) : '');

	useEffect(() => {
		$("#root>*").css({ display: "none" });
		if (animation === "fadein") {
			$("body").css({
				opacity: "0",
				display: "block",
				margin: "unset",
			})
			$("body").animate({ opacity: "1" }, 300, function () {
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "slideup") {
			$("body").css({
				position: "fixed",
				top: "105vh",
				right: "0",
				bottom: "0",
				left: "0",
				display: "block",
				margin: "unset",
			})
			$("body").animate({ top: "0", }, 500, function () {
				$(this).css({ position: "unset" });
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "slideright") {
			$("body").css({
				position: "fixed",
				top: "0",
				right: "105vw",
				bottom: "0",
				left: "-40vw",
				display: "block",
				margin: "unset",
				width: "unset",
			})
			$("body").animate({
				right: "0",
				left: "0",
			}, 500, function () {
				$(this).css({ position: "unset" });
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "slidedown") {
			$("body").css({
				display: "block",
				height: "-2vh",
				margin: "unset",
			})
			$("body").animate({ height: "100vh", }, 500, function () {
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "slideleft") {
			$("body").css({
				position: "fixed",
				top: "0",
				right: "0",
				bottom: "0",
				left: "105vw",
				display: "block",
				margin: "unset",
			})
			$("body").animate({
				left: "0",
			}, 500, function () {
				$(this).css({ position: "unset" });
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "zoom") {
			$("body").css({
				top: '0',
				right: "0",
				bottom: "0",
				left: "0",
				height: "0vh",
				width: "0vw",
				display: "block",
				position: "fixed",
				margin: "auto",
			});
			$("body").animate({ height: '100vh', width: "100vw" }, 500, function () {
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "clip") {
			$("body").css({
				top: '0',
				right: "0",
				bottom: "0",
				left: "0",
				height: "0vh",
				display: "block",
				position: "fixed",
				margin: "auto",
			});
			$("body").animate({ height: '100vh' }, 500, function () {
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else if (animation === "puff") {
			$("body").css({
				top: '0',
				right: "0",
				bottom: "-20vh",
				left: "-20vw",
				height: "140vh",
				width: "140vw",
				display: "block",
				position: "fixed",
				margin: "auto",
			});
			$("body").animate({ height: "100vh", width: '100vw', left: "0", bottom: "0" }, 500, function () {
				$("#root>*").css({ display: "block" });
				$("#root .footer-box").css({ display: "flex" });
			});
		} else {
			$("body, #root>*").css({
				display: "block"
			});
			$("#root .footer-box").css({ display: "flex" });
		}
	}, [animation]);

	function handleChangeLang(updatedLang) {
		setLang(updatedLang);
	}

	function handleChangeSettings(updatedSettings) {
		setSettings(updatedSettings);
	}

	function handleChangeFavorites(updatedFav) {
		setFavorites(updatedFav);
	}

	function loadDefaultBackgroundImage() {
		if (selectedImage === null) {
			let images = JSON.parse(localStorage.getItem("images"));
			if (!images) {
				images = imagesJSON;
				localStorage.setItem("images", JSON.stringify(imagesJSON));
			}
			if (localStorage.getItem("checkbox-option") === "selected") {
				const image = (localStorage.getItem("default-image")) ? localStorage.getItem("default-image") : bg_01;
				$(".last-bg").css("background-image", 'unset');
				$("#root").css("background-image", `url(${image})`);
			} else if (localStorage.getItem("checkbox-option") === "fav") {
				const image = (localStorage.getItem("default-image")) ? localStorage.getItem("default-image") : bg_01;
				$(".last-bg").css("background-image", `url(${image})`);
				let imagesFav = [];
				for (const item of images) {
					if (item.fav) {
						imagesFav.push(item);
					}
				} if (imagesFav.length > 0) {
					const index = Math.floor(Math.random() * (imagesFav.length) + 0);
					$("#root").css("background-image", `url(${imagesFav[index].full})`);
					localStorage.setItem("default-image-name", imagesFav[index].name);
					localStorage.setItem("default-image", imagesFav[index].full);
					setSelectedImage(imagesFav[index].name);
				} else {
					const index = Math.floor(Math.random() * (images.length) + 0);
					$("#root").css("background-image", `url(${images[index].full})`);
					localStorage.setItem("default-image-name", images[index].name);
					localStorage.setItem("default-image", images[index].full);
					setSelectedImage(images[index].name);
				}
			} else {
				const image = (localStorage.getItem("default-image")) ? localStorage.getItem("default-image") : bg_01;
				$(".last-bg").css("background-image", `url(${image})`);
				const index = Math.floor(Math.random() * (images.length) + 0);
				$("#root").css("background-image", `url(${images[index].full})`);
				localStorage.setItem("default-image-name", images[index].name);
				localStorage.setItem("default-image", images[index].full);
				setSelectedImage(images[index].name);
			}
		}
	}

	useEffect(() => {
		loadDefaultBackgroundImage();

		let autoHideValue = getComponentValue("autoHide", settings);
		if (autoHideInterval === null && autoHideValue) {
			setAutoHideInterval(setInterval(() => {
				if (countdown <= 0) {
					$("#root>*").fadeOut(300);
					$("body").css({ cursor: "none" });
				} else {
					countdown--;
				}
			}, 1100));
		} else if (autoHideInterval != null && !autoHideValue) {
			clearInterval(autoHideInterval);
			setAutoHideInterval(null);
		}
		$("body").on("mousemove", () => {
			countdown = 5;
			$("#root>*").fadeIn(200);
			$("body").css({ cursor: "default" });
		});

		setShowApps(getComponentValue("showApps", settings));
		setShowFavorites(getComponentValue("showFavorites", settings));
		setShowFooter(getComponentValue("showFooter", settings));
		setAnimation(getComponentValue("animation", settings));
		setConfigApps(getConfigComponent("configApps", settings));
		setConfigFavorites(getConfigComponent("configFavorites", settings));
		setConfigFooter(getConfigComponent("configFooter", settings));

		const blindType = getComponentValue("blindFilter", settings);
		if (blindType !== "none") {
			$("body").css({ filter: `url('${blindFilter}#${blindType}')` });
		} else {
			$("body").css({ filter: `none` });
		}

		if (getComponentValue("darkMode", settings)) {
			$("body").addClass("dark");
		} else {
			$("body").removeClass("dark");
		}
	})

	loadBackgroundImages();
	return (
		<>
			{(showFavorites) ? <FavoritesApps lang={lang} favorites={favorites} config={configFavorites} /> : ''}
			{(!showFavorites && showApps) ? <Apps className="to-left" config={configApps} /> : (showFavorites && showApps) ? <Apps config={configApps} /> : ''}
			<Options onChangeLang={handleChangeLang} onChangeSettings={handleChangeSettings} onChangeFavorites={handleChangeFavorites} />
			{(showFooter) ? <Footer favorites={favorites} config={configFooter} /> : ''}
			<ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</>
	);
}

export default Home;
